// Buffer polyfill for browser environment
// This makes Buffer available globally using the buffer package
// This avoids the vite-plugin-node-polyfills shim import issue

import { Buffer } from 'buffer';

if (typeof globalThis !== 'undefined' && typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}

